import React from 'react';
import PropTypes from 'prop-types';

import { NavigationItemSt, LinkSt, IconSt } from './NavigationItem.css';

export class NavigationItem extends React.PureComponent {
  render() {
    const {
      children,
      className,
      border,
      icon,
      isActive,
      isSubItem,
      onClick,
      title,
      to,
    } = this.props;

    return (
      <NavigationItemSt
        border={border}
        className={className}
        isSubItem={isSubItem}
        isActive={isActive}
        onClick={onClick}
        to={to}
      >
        <LinkSt to={to}>
          {icon && <IconSt className={`if-icon-${icon}`} />}
          {title}
        </LinkSt>
        {children}
      </NavigationItemSt>
    );
  }
}

NavigationItem.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  border: PropTypes.bool,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  isSubItem: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.any.isRequired,
  to: PropTypes.string,
};

NavigationItem.defaultProps = {
  border: false,
  children: null,
  icon: null,
  isActive: false,
  isSubItem: false,
  onClick: () => {},
  to: null,
};
